// ÐÐ¾Ð³Ð¾ÑÐ¸Ð¿Ñ Ð¸ ÑÐ¾Ð½ Ð°Ð²ÑÐ¾ÑÐ¸Ð·Ð°ÑÐ¸Ð¸ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð³Ð¾ Ð±ÑÐµÐ½Ð´Ð°.
//
// Ð¤Ð°Ð¹Ð»Ñ Ð»ÐµÐ¶Ð°Ñ Ð² src/brand/<Ð±ÑÐµÐ½Ð´>/. require Ñ ÑÐ°Ð±Ð»Ð¾Ð½Ð¾Ð¼ Ð·Ð°ÑÑÐ°Ð²Ð»ÑÐµÑ webpack
// Ð¿Ð¾Ð»Ð¾Ð¶Ð¸ÑÑ Ð² ÑÐ±Ð¾ÑÐºÑ Ð¾Ð±Ð° Ð½Ð°Ð±Ð¾ÑÐ° Ð¸ Ð²ÑÐ±ÑÐ°ÑÑ Ð½ÑÐ¶Ð½ÑÐ¹ Ð¿Ð¾ BRAND Ð½Ð° ÑÑÐ°ÑÑÐµ â ÑÐ°Ðº
// ÑÐ±Ð¾ÑÐºÐ° Ð½Ðµ Ð·Ð°Ð²Ð¸ÑÐ¸Ñ Ð¾Ñ Ð¿Ð¾ÑÑÐ´ÐºÐ° Ð¸Ð¼Ð¿Ð¾ÑÑÐ¾Ð².
import { BRAND } from './brand';

export const logo = require(`./${BRAND}/logo.svg`);
export const authLogo = require(`./${BRAND}/authLogo.svg`);
export const authBackground = require(`./${BRAND}/background.jpg`);
